import { Form, Select, Input } from "antd";

import { QueryParams, RVFormItem } from "@regal-voice/ui";
import { withApolloQuery } from "HOC/withApolloQuery";
import { withSortedData } from "HOC/withSortedData";
import { getQueues } from "Services/marketing-api/tasks/queries";

type Queue = {
    sid: string;
    friendlyName: string;
    transferEligible: boolean;
};

interface QueueTransferProps extends Record<string, unknown> {
    data?: Queue[];
}

const defaultQueryParams: QueryParams = {
    pageSize: 25,
    page: 0,
    orderBy: [
        {
            key: "name",
            value: "ASC",
        },
    ],
    filterBy: [],
};

function QueueTransfer({ data }: QueueTransferProps): JSX.Element {
    const form = Form.useFormInstance();
    return (
        <>
            <RVFormItem name="queueSid" hidden>
                <Input autoFocus size="large" />
            </RVFormItem>
            <RVFormItem name="queueName" hidden>
                <Input autoFocus size="large" />
            </RVFormItem>
            <RVFormItem name="internalQueueName">
                <Select
                    placeholder="Select a queue"
                    size="large"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    onSelect={(value, option) => {
                        form.setFieldsValue({
                            queueSid: option.key,
                            queueName: value,
                        });
                    }}
                >
                    {(data || []).map(({ sid, friendlyName }) => (
                        <Select.Option key={sid} value={friendlyName}>
                            {friendlyName}
                        </Select.Option>
                    ))}
                </Select>
            </RVFormItem>
        </>
    );
}

export function compareOptions(left: Queue, right: Queue): number {
    return left.friendlyName < right.friendlyName ? -1 : 1;
}

const SortedQueueTransfer = withSortedData(QueueTransfer, compareOptions);

export function transformData(responseData?: { queues: Queue[] }): Queue[] {
    return (responseData?.queues ?? []).filter((queue: Queue) => !!queue.transferEligible);
}

export const QueueInternalTransfer = withApolloQuery<
    QueueTransferProps,
    Queue[],
    { queues: Queue[] },
    { queryParams: QueryParams }
>(
    SortedQueueTransfer,
    getQueues,
    {
        fetchPolicy: "no-cache",
        variables: { queryParams: defaultQueryParams },
    },
    transformData
);
